export default "__VITE_ASSET__CHDp0MrQ__"